/**
 * Copies text to the clipboard using the Clipboard API
 * @param text - Text to copy to clipboard
 * @returns Promise with success status and optional error
 */
export const copyToClipboard = async( text: string ): Promise<{ success: boolean, error?: Error }> => {
	try {
		await navigator.clipboard.writeText( text )
		return { success: true }
	} catch ( error ) {
		return {
			success: false,
			error: error instanceof Error ? error : new Error( 'Unknown error copying to clipboard' ),
		}
	}
}
